<template>
  <div class="CmsContentsFiledsList">
    <div class="contentsWidth mx-auto mt-4">

      <div class="">
        <p class="title mb-0">報告管理 - 一覧</p>
        <hr class="title">
      </div>

      <div id="serchWrap" class="mt-4">
        <div class="bold">絞り込み条件</div>
        <div class="search_area flex flexCenter">
          <!-- No.23 §16：表示対象（報告／アンケート／採択者手続き〔zz09〕）。母集合・列・ボタンをモードで出し分ける。 -->
          <div class="searchShort inlineBlock searchSpace">
            <div>表示対象</div>
            <div>
              <b-form-select
                @input="setMode($event)"
                :value="search.mode"
                :options="modeList"/>
            </div>
          </div>
          <!-- No.23 §16-9：回答状況（アンケートモードのみ）。既定は「回答あり」 -->
          <div v-if="isSurveyMode" class="searchShort inlineBlock searchSpace">
            <div>回答状況</div>
            <div>
              <b-form-select
                @input="setAnswered($event)"
                :value="search.answered"
                :options="answeredList"/>
            </div>
          </div>
          <!-- zz09：手続き状況（採択者手続きモードのみ）。既定は「保存あり」 -->
          <div v-if="isAdoptionMode" class="searchShort inlineBlock searchSpace">
            <div>手続き状況</div>
            <div>
              <b-form-select
                @input="setSaved($event)"
                :value="search.saved"
                :options="savedList"/>
            </div>
          </div>
          <div class="searchMiddle inlineBlock searchSpace">
            <div>申請番号</div>
            <div>
              <b-form-input
                @input="setFilter('code', $event)"
                :value="search.code"
                placeholder="入力してください。"/>
            </div>
          </div>
          <div class="searchMiddle inlineBlock searchSpace">
            <div>報告者名</div>
            <div>
              <b-form-input
                @input="setFilter('name', $event)"
                :value="search.name"
                placeholder="入力してください。"/>
            </div>
          </div>
          <div class="searchShort inlineBlock searchSpace">
            <div>年度</div>
            <div>
              <b-form-select
                @input="setFilter('year', $event)"
                :value="search.year"
                :options="yearList">
                <template v-slot:first>
                  <option :value="'all'">すべて</option>
                </template>
              </b-form-select>
            </div>
          </div>
          <div class="searchMiddle inlineBlock searchSpace">
            <div>助成種別</div>
            <div>
              <b-form-select
                @input="setFilter('series', $event)"
                :value="search.series"
                :options="seriesList">
                <template v-slot:first>
                  <option :value="null">-- 未選択 --</option>
                </template>
              </b-form-select>
            </div>
          </div>
          <!-- ステータスは報告モードのみ（アンケートモードでは意味を持たない） -->
          <div v-if="isReportMode" class="searchMiddle inlineBlock">
            <div>ステータス</div>
            <div>
              <b-form-select
                @input="setFilter('status', $event)"
                :value="search.status"
                :options="statusList">
                <template v-slot:first>
                  <option :value="''">-- 未選択 --</option>
                </template>
              </b-form-select>
            </div>
          </div>
        </div>
      </div>

      <div class="contentsWidth mt-2">
        <div class="flex flex-between my-2">
          <b-pagination
            class="mb-1"
            aria-controls="fieldTable"
            :value="currentPage"
            @input="setCurrentPage($event)"
            :total-rows="totalRows"
            :per-page="perPage"
          />
          <div>
            <div class="inlineBlock mr-2">
              {{nowPageCount}}件 / 全{{totalRows}}件
            </div>
            <div class="inlineBlock">
              <span class="mr-2">表示件数</span>
              <b-form-select
                class="per-page-select"
                :value="perPage"
                @change="setPerPage"
                :options="pageOptions"
              />
            </div>
          </div>
        </div>

        <b-table striped hover
          id='fieldTable'
          table-class="cmsAppTable"
          thead-class="tableHead"
          tbody-tr-class="dataWrap"
          :items="repList"
          :fields="header"
          :filter="search"
          :filter-function="filtering"
          @filtered="onFiltered"
          show-empty
          :per-page="perPage"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @sort-changed="onSortChanged"
        >
          <template v-slot:emptyfiltered="scope">
            <div class="flex flexCenter">条件に一致するデータがありません。</div>
          </template>
          <template
            v-slot:head(checkbox)>
            <b-link
              id="popover"
              class="ml-1">全選択/全解除</b-link>
            <b-popover
              target="popover"
              title=""
              triggers="hover"
              placement="right"
            >
              <template v-slot:default>
                <p class="mb-0 link" @click="pageSelect">ページ内全選択</p>
                <p class="mb-0 link" @click="pageRemove">ページ内全解除</p>
                <p class="mb-0 link" @click="allSelect">全選択</p>
                <p class="mb-0 link" @click="allRemove">全解除</p>
              </template>
            </b-popover>
          </template>
          <template v-slot:cell(checkbox)="row">
            <div class="flex flexCenter">
              <b-form-checkbox
                @change="updateSelectedRepIdList($event, row.item.id)"
                :checked="selectedRepIdList"
                :value="row.item.id"
                />
            </div>
          </template>
          <!-- kanaでソートをするが、表示を漢字名 -->
          <template v-slot:cell(kana)="row">
            {{row.item.name}}
          </template>
          <!-- アンケートモードからはアンケートタブを開いた状態で遷移する。
               報告レコードが無い採択者（未着手）と、アンケートを1回も実施していない
               助成種別（開く先のアンケートタブが無い）はリンクを出さない。 -->
          <template v-slot:cell(btn)="row">
            <b-link v-if="canEdit(row.item)" :to="editLink(row.item.reportId)">
              編集
            </b-link>
            <!-- No.23 §21：取下げで編集画面を開けない行は理由だけ出す（リンクにしない） -->
            <span v-else-if="showWithdrawnReason(row.item)" class="text-muted small">
              報告取下済み
            </span>
          </template>
        </b-table>
      </div>
    </div>

    <div class="mt-5 mb-3 flex flexCenter contentsWidth mx-auto">
      <b-button
        class="btn btn-lg bold"
        to="/cms/top">トップに戻る</b-button>
      <b-button
        v-if="isReportMode"
        variant="primary"
        class="btn btn-primary btn-lg bold ml-2"
        :disabled="selectedRepIdList.length < 1"
        @click="control(status['RECEIPT'])"
        >一括受領</b-button>
      <b-button
        v-if="isReportMode"
        variant="primary"
        class="btn btn-primary btn-lg bold ml-2"
        :disabled="!canExportPdf"
        @click="exportPdf()"
        >PDF出力</b-button>
      <!-- No.23 §15/§16：アンケートCSV出力（アンケートモードのみ）。
           活性条件は PDF出力と同一（年度＋助成種別の選択＋1件以上のチェック）。 -->
      <b-button
        v-if="isSurveyMode"
        variant="primary"
        class="btn btn-primary btn-lg bold ml-2"
        :disabled="!canExportSurveyCsv"
        @click="exportSurveyCsv()"
        >アンケートCSV出力</b-button>
    </div>
    <!-- No.23 §25（C-8）：年度「すべて」では出力対象（設問＝列／様式）が決まらないため押せない。
         押せない理由が分かるように注記を出す（ボタン自体は消さない＝§12/§20/§21 と同じ作法）。 -->
    <div v-if="showExportHint" class="mb-3 text-center text-muted small contentsWidth mx-auto">
      年度と助成種別を選択してください。
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import api from '@/modules/api';
import CONST_STATUS from '@/constants/appStatus';
// eslint-disable-next-line
import download from '@/modules/download';

export default {
  name: 'CmsApplicationsList',
  data() {
    return {
      status: CONST_STATUS.APP_STATUS,
      statusList: CONST_STATUS.CMS_REP_STATUS_OPTION_4_LIST,
      dbRepList: [],
      // No.23 §16：表示対象の選択肢（既定＝報告）
      modeList: [
        { value: 'report', text: '報告' },
        { value: 'survey', text: 'アンケート' },
        // zz09：採択者手続き（採択者全員を母集合に、採択者手続きの保存状況を出す）
        { value: 'adoption', text: '採択者手続き' },
      ],
      // No.23 §16-9：回答状況の選択肢（既定＝回答あり）
      answeredList: [
        { value: 'answered', text: '回答あり' },
        { value: 'unanswered', text: '未回答' },
        { value: 'all', text: 'すべて' },
      ],
      // zz09：手続き状況の選択肢（既定＝保存あり。一時保存・登録は区別しない）
      savedList: [
        { value: 'saved', text: '保存あり' },
        { value: 'unsaved', text: '未保存' },
        { value: 'all', text: 'すべて' },
      ],
      pageOptions: [
        { value: 1, text: 1 },
        { value: 10, text: 10 },
        { value: 20, text: 20 },
        { value: 50, text: 50 },
        // { value: 0, text: 'すべて' },
      ],
      rawSeriesList: [],
      yearList: [],
      isInit: true,
      oldPage: 1,
      // No.15: sortBy/sortDesc は Vuex (cmsReportSearch) に移行し computed バインド化（列ラベルは「報告者名」のまま）
      tableShowData: [],
    };
  },
  methods: {
    onSortChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.setSortedData();
    },
    setSortedData() {
      if (this.sortBy) {
        const sortedData = this.tableShowData.slice().sort((a, b) => {
          let result = 0;
          if (a[this.sortBy] < b[this.sortBy]) {
            result = -1;
          } else if (a[this.sortBy] > b[this.sortBy]) {
            result = 1;
          }
          return this.sortDesc ? -result : result;
        });
        this.$store.commit('cmsReportSearch/setFilterdIdList', sortedData);
      }
    },
    setFilter(key, value) {
      const param = { key, value };
      this.$store.commit('cmsReportSearch/setFilter', param);
    },
    // No.23 §16：表示対象の切替。母集合が変わるため選択をクリアして取り直す。
    async setMode(mode) {
      // 報告とアンケートでは行の形が違う（報告＝user_info を持つ／アンケート＝氏名を直持ち）。
      // 前モードの行を抱えたまま再描画すると repList の整形で落ちて画面が更新されないため、
      // 取得し直す前に必ず空にする。
      this.dbRepList = [];
      this.$store.commit('cmsReportSearch/setMode', mode);
      this.$store.dispatch('page/onLoading');
      await this.fetchRepList();
      this.$store.dispatch('page/offLoading');
    },
    // No.23 §16-9：回答状況の切替。母集合が変わるため選択をクリアして取り直す。
    async setAnswered(answered) {
      this.$store.commit('cmsReportSearch/setFilter', { key: 'answered', value: answered });
      this.$store.commit('cmsReportSearch/initSelectedAppid');
      this.$store.dispatch('page/onLoading');
      await this.fetchRepList();
      this.$store.dispatch('page/offLoading');
    },
    // zz09：手続き状況の切替。母集合が変わるため選択をクリアして取り直す。
    async setSaved(saved) {
      this.$store.commit('cmsReportSearch/setFilter', { key: 'saved', value: saved });
      this.$store.commit('cmsReportSearch/initSelectedAppid');
      this.$store.dispatch('page/onLoading');
      await this.fetchRepList();
      this.$store.dispatch('page/offLoading');
    },
    // 編集リンクを出すか。アンケートモードは報告レコードがあり、かつ
    // その助成種別でアンケートを1回でも実施している行だけ（開く先のタブが無いため）。
    canEdit(item) {
      // zz09：採択者手続きタブは常にあるため、採択者手続きモードは報告レコードの有無だけを見る
      if (!this.isSurveyMode) {
        return !!item.reportId;
      }
      return !!item.reportId && !!item.hasRounds;
    },
    // No.23 §21：編集リンクの代わりに理由を出すか。報告を取下げると report_id が消えて
    // 編集画面を開けない（取下済みの repId では getAppBaseInfo が null を返し 500 になる）ため、
    // クリックさせずテキストで理由だけを示す。再提出後は report_id が復活し「編集」に戻る。
    showWithdrawnReason(item) {
      return !this.isReportMode && !item.reportId && !!item.withdrawn;
    },
    // アンケートモード・採択者手続きモードからは、それぞれのタブを開いた状態で編集画面へ遷移する
    editLink(repId) {
      if (this.isSurveyMode) {
        return `/cms/reports/edit/${repId}?tab=survey`;
      }
      if (this.isAdoptionMode) {
        return `/cms/reports/edit/${repId}?tab=adoption`;
      }
      return `/cms/reports/edit/${repId}`;
    },
    async initFetch() {
      // No.15: 画面戻り時の sortBy 維持のため、ここでのリセットは行わない
      //        検索条件変更時のリセットは cmsReportSearch/setFilter mutation 側で実施
      const promiseFuncs = [api.send('/api/cms/reports/init')];
      const responses = await api.all(promiseFuncs)
        .catch((err) => {
          console.log(err);
        });
      this.rawSeriesList = responses[0].data.seriesList;
      this.yearList = responses[0].data.yearList;
      // 年度が選択されていなければ、最新の年度を選択状態にする。
      // ★commit 先は報告管理の store（cmsReportSearch）。申請管理（cmsApplicationSearch）へ
      //   commit していたため、ヘッダーの「報告管理」を2回押すと年度が空のまま復旧せず、
      //   代わりに申請管理の年度が書き換わっていた。
      if (!this.search.year && this.yearList.length > 0) {
        const yearParam = { key: 'year', value: this.yearList[0] };
        this.$store.commit('cmsReportSearch/setFilter', yearParam);
      }
      await this.fetchRepList();
    },
    // 報告一覧取得
    async fetchRepList() {
      const param = {
        year: this.search.year,
        series: null,
        // No.23 §16：報告／アンケートの母集合切替
        mode: this.search.mode,
        // No.23 §16-9：回答状況（アンケートモードでのみ使われる）
        answered: this.search.answered,
        // zz09：手続き状況（採択者手続きモードでのみ使われる）
        saved: this.search.saved,
      };
      const response = await api.send('/api/cms/reports/list', param)
        .catch((err) => {
          console.log(err);
        });
      // 表示対象を続けて切り替えると応答の到着順が入れ替わりうる。
      // 送信時と表示対象が変わっていたら、形の違う行を取り込まない。
      if (this.search.mode !== param.mode) {
        return;
      }
      this.dbRepList = response.data.repList;
    },
    // フィルター用 search変更時に各行に対して走る
    filtering(lineData, search) {
      const nameSort = search.name === '' || lineData.name.includes(search.name);
      const reptypeSort = search.series === null || lineData.seriesId === search.series;
      // const yearSort = search.year === null || lineData.year === search.year;
      const codeSort = search.code === '' || lineData.code.includes(search.code);
      // ステータス絞り込みは報告モードのみ（アンケートモードでは常に通す）
      const statusSort = search.mode !== 'report'
        || search.status === '' || lineData.status === Number(search.status);
      return nameSort && reptypeSort && codeSort && statusSort;
    },
    onFiltered(filteredItems) {
      this.$store.commit('cmsReportSearch/setTotalRows', filteredItems.length);
      if (this.isInit) {
        this.$store.commit('cmsReportSearch/setCurrentPage', this.oldPage);
      } else {
        this.$store.commit('cmsReportSearch/setCurrentPage', 1);
      }
      // 全選択・ページ内全選択で使う行キーの一覧（報告モード＝report_id／アンケートモード＝user_id）。
      // ※編集画面の「前の申請／次の申請」もこの一覧を見るが、アンケートモードでは
      //   Edit 側で前後遷移を無効化している（キーが report_id ではないため）。
      this.$store.commit('cmsReportSearch/initSelectedAppid');
      this.$store.commit('cmsReportSearch/setFilterdIdList', filteredItems);
      this.tableShowData = filteredItems;
      this.setSortedData();
    },
    async control(status) {
      const count = this.selectedRepIdList.length;
      let msg = `選択中の${count}件の報告のステータスを受領に変更します。`;
      msg += '\nステータスが変更されると、報告者にメールの送信と通知の登録が行われます。\n受領してもよろしいですか？';
      if (!await this.confirm(msg)) {
        return;
      }
      this.$store.dispatch('page/onWaiting');
      const params = {
        status,
        selectedRepIdList: this.selectedRepIdList,
      };
      const response = await api.send('/api/cms/reports/control', params)
        .catch((err) => {
          console.log(err);
        });
      if (!response) {
        return;
      }
      await this.alert('選択した報告を受領しました。', false);
      await this.initFetch(this.search.year);
      this.$store.dispatch('page/offWaiting');
    },
    allSelect() {
      this.$store.commit('cmsReportSearch/allSelectedAppid');
    },
    allRemove() {
      this.$store.commit('cmsReportSearch/initSelectedAppid');
    },
    pageSelect() {
      const start = (this.currentPage - 1) * (this.perPage);
      const end = this.currentPage * this.perPage;
      const idListOnPage = this.filterdIdList.slice(start, end);
      idListOnPage.forEach((appId) => {
        this.$store.commit('cmsReportSearch/addSelectedAppid', appId);
      });
    },
    pageRemove() {
      const start = (this.currentPage - 1) * (this.perPage);
      const end = this.currentPage * this.perPage;
      const idListOnPage = this.filterdIdList.slice(start, end);
      idListOnPage.forEach((appId) => {
        this.$store.commit('cmsReportSearch/removeSelectedAppid', appId);
      });
    },
    async exportPdf() {
      if (!this.canExportPdf) {
        return;
      }
      this.$store.dispatch('page/onWaiting');
      const params = {
        selectedRepIdList: this.selectedRepIdList,
        seriesId: this.search.series,
        year: this.search.year,
      };
      const requireBlob = true;
      const response = await api.send('/api/cms/reports/export/pdf', params, requireBlob)
        .catch((err) => {
          console.log(err);
        });
      this.$store.dispatch('page/offWaiting');
      if (!response) {
        // eslint-disable-next-line
        await this.alert('ファイルのダウンロードに失敗しました。');
        return;
      }
      const ymd = moment().format('YYYYMMDD');
      const series = this.seriesList.find((data) => {
        return data.value === this.search.series;
      });
      const fileName = `${ymd}_${series.text}.pdf`;
      download.blob(response.data, fileName);
    },
    // No.23 §15：アンケートCSV出力（名簿型・チェックした行のみ）
    async exportSurveyCsv() {
      if (!this.canExportSurveyCsv) {
        return;
      }
      this.$store.dispatch('page/onWaiting');
      const params = {
        // No.23 §16-9：アンケートモードのチェックは user_id を保持している
        selectedUserIdList: this.selectedRepIdList,
        seriesId: this.search.series,
        year: this.search.year,
      };
      const requireBlob = true;
      const response = await api.send('/api/cms/reports/export/survey/csv', params, requireBlob)
        .catch((err) => {
          console.log(err);
        });
      this.$store.dispatch('page/offWaiting');
      if (!response) {
        // eslint-disable-next-line
        await this.alert('ファイルのダウンロードに失敗しました。');
        return;
      }
      const ymd = moment().format('YYYYMMDD');
      const series = this.seriesList.find((data) => {
        return data.value === this.search.series;
      });
      const fileName = `${ymd}_${series.text}_アンケート.csv`;
      download.csvUtf(response.data, fileName);
    },
    updateSelectedRepIdList(event, appId) {
      if (!event) {
        this.$store.commit('cmsReportSearch/removeSelectedAppid', appId);
      } else {
        const isChecked = event.find((id) => {
          return id === appId;
        });
        if (!isChecked) {
          this.$store.commit('cmsReportSearch/removeSelectedAppid', appId);
        } else {
          this.$store.commit('cmsReportSearch/addSelectedAppid', appId);
        }
      }
    },
    setCurrentPage(page) {
      this.$store.commit('cmsReportSearch/setCurrentPage', page);
    },
    setPerPage(page) {
      this.$store.commit('cmsReportSearch/setPerPage', page);
    },
    setTotalRows(value) {
      this.$store.commit('cmsReportSearch/setTotalRows', value);
    },
  },
  computed: {
    // No.23 §16：表示対象。zz09 で採択者手続きが加わったため、3 つを明示的に判定する
    // （「アンケート以外＝報告」としていると採択者手続きモードに一括受領・PDF が出る）
    isReportMode() {
      return this.search.mode === 'report';
    },
    isSurveyMode() {
      return this.search.mode === 'survey';
    },
    isAdoptionMode() {
      return this.search.mode === 'adoption';
    },
    // 列はモードで出し分ける（アンケートモードではステータス列を出さない）
    header() {
      // No.23 §26（C-9）：アンケートモードの行は 申請番号（mst_applications.code）＋氏名。
      // 母集合が採択者全員（§16-9）で、報告を書いていない人には報告番号も報告者情報も無いため、
      // 報告モードのラベル（報告番号／報告者名）をそのまま出すと中身と食い違う。
      // 「氏名」は報告者情報にフォールバックしても成立する中立な語（アンケートCSV も 氏名）。
      // zz09：採択者手続きモードも母集合が採択者全員のため、アンケートモードと同じラベルにする。
      const isAdopteeBase = !this.isReportMode;
      const head = [];
      // zz09：採択者手続きモードは一括操作が無いため、チェックボックスの列を出さない
      if (!this.isAdoptionMode) {
        head.push({ key: 'checkbox', label: '', sortable: false });
      }
      head.push(
        { key: 'code', label: isAdopteeBase ? '申請番号' : '報告番号', sortable: true },
        { key: 'kana', label: isAdopteeBase ? '氏名' : '報告者名', sortable: true },
        { key: 'year', label: '年度', sortable: true },
        { key: 'reptype', label: '助成種別', sortable: true },
      );
      if (this.isReportMode) {
        head.push({ key: 'statusText', label: 'ステータス', sortable: true });
      }
      if (this.isAdoptionMode) {
        head.push(
          { key: 'donation', label: '寄付申込書', sortable: true },
          { key: 'exemption', label: '間接経費免除申請書', sortable: true },
          { key: 'updatedAt', label: '最終更新日時', sortable: true },
        );
      }
      head.push({ key: 'btn', label: '', sortable: false });
      return head;
    },
    // No.15: ソート状態を Vuex (cmsReportSearch) にバインド
    sortBy: {
      get() { return this.$store.state.cmsReportSearch.sortBy; },
      set(v) { this.$store.commit('cmsReportSearch/setSortBy', v); },
    },
    sortDesc: {
      get() { return this.$store.state.cmsReportSearch.sortDesc; },
      set(v) { this.$store.commit('cmsReportSearch/setSortDesc', v); },
    },
    search() {
      return this.$store.state.cmsReportSearch.search;
    },
    currentPage() {
      return this.$store.state.cmsReportSearch.currentPage;
    },
    perPage() {
      return this.$store.state.cmsReportSearch.perPage;
    },
    totalRows() {
      return this.$store.state.cmsReportSearch.totalRows;
    },
    repList() {
      if (!this.dbRepList) {
        return [];
      }
      // No.23 §16-9：アンケートモードは採択者起点。行のキーは user_id で、
      // 報告レコードが無い採択者は reportId が null（編集リンクを出さない）。
      // zz09：採択者手続きモードも採択者起点（行のキーは user_id）。
      // 寄付申込書・間接経費免除申請書は、採択者手続きを保存していない行では空欄にする。
      if (this.isAdoptionMode) {
        return this.dbRepList.map((row) => {
          const hasAdoption = !!Number(row.has_adoption);
          const fileText = (flag) => {
            if (!hasAdoption) {
              return '';
            }
            return Number(flag) ? '有' : '無';
          };
          return {
            id: row.user_id,
            reportId: row.report_id,
            withdrawn: !!Number(row.withdrawn),
            reptype: row.apptype_name,
            name: `${row.sei} ${row.mei}`,
            kana: `${row.kana_sei} ${row.kana_mei}`,
            year: row.year,
            code: row.code,
            seriesId: row.series_id,
            donation: fileText(row.has_donation),
            exemption: fileText(row.has_exemption),
            updatedAt: row.adoption_updated_at
              ? moment(row.adoption_updated_at).format('YYYY/MM/DD HH:mm') : '',
          };
        });
      }
      if (!this.isReportMode) {
        return this.dbRepList.map((row) => {
          return {
            id: row.user_id,
            reportId: row.report_id,
            // その助成種別でアンケートを実施しているか（編集リンクの出し分けに使う）
            hasRounds: !!Number(row.has_rounds),
            // No.23 §21：取下済みの報告があるか（編集できない理由の表示に使う）
            withdrawn: !!Number(row.withdrawn),
            reptype: row.apptype_name,
            name: `${row.sei} ${row.mei}`,
            kana: `${row.kana_sei} ${row.kana_mei}`,
            year: row.year,
            code: row.code,
            seriesId: row.series_id,
          };
        });
      }
      const repList = this.dbRepList.map((report) => {
        return {
          id: report.id,
          reportId: report.id,
          reptypeId: report.report_type_id,
          reptype: report.apptype_name,
          name: `${report.user_info.sei} ${report.user_info.mei}`,
          kana: `${report.user_info.kana_sei} ${report.user_info.kana_mei}`,
          year: report.year,
          code: report.code,
          status: report.status,
          statusText: CONST_STATUS.APP_STATUS_TEXTS[report.status],
          seriesId: report.series_id,
        };
      });
      return repList;
    },
    seriesList() {
      if (!this.rawSeriesList) {
        return [];
      }
      return this.rawSeriesList.map((series) => {
        return { value: series.id, text: series.name };
      });
    },
    // チェック中の行キー。報告モードは report_id、アンケートモードは user_id を保持する
    // （モード切替時に必ずクリアされるため混在しない・§16-9）。
    selectedRepIdList() {
      if (!this.$store.state.cmsReportSearch.selectedRepIdList) {
        return [];
      }
      return this.$store.state.cmsReportSearch.selectedRepIdList;
    },
    filterdIdList() {
      return this.$store.state.cmsReportSearch.filterdIdList;
    },
    canExportPdf() {
      return this.selectedRepIdList.length > 0 && this.isExportTargetFixed;
    },
    // No.23 §25（C-8）：アンケートCSV出力の活性条件（PDF出力と同一）
    canExportSurveyCsv() {
      return this.selectedRepIdList.length > 0 && this.isExportTargetFixed;
    },
    // No.23 §25（C-8）：出力対象が一意に決まっているか。
    // CSV はヘッダーが ［回名］設問文 なので年度＋助成種別が決まらないと列が定まらず、
    // PDF は1つの報告種別の様式で出力するため、どちらも年度を1つに絞る必要がある。
    // ★年度セレクトには「すべて」（'all'）があるため null チェックだけでは足りない
    //   （従来は押せてしまい、サーバで助成種別を解決できず 500 になっていた）。
    //   判定は CSV／PDF で共有する（別々に持つと片方だけ直してズレるため）。
    isExportTargetFixed() {
      const { year, series } = this.search;
      return !!series && year !== null && year !== 'all';
    },
    // No.23 §25：出力できない理由を出すか。
    // チェックが0件のときは「まず対象を選ぶ」段階なので出さない（常時表示になって邪魔）。
    showExportHint() {
      return this.selectedRepIdList.length > 0 && !this.isExportTargetFixed;
    },
    nowPageCount() {
      if (this.totalRows === 0) {
        return 0;
      }
      let maxPage = Math.floor(this.totalRows / this.perPage);
      // 上記計算にあまりがあれば、ページ数をプラス1
      const mod = this.totalRows % this.perPage;
      let lastPageItemNum;
      if (mod !== 0) {
        maxPage += 1;
        lastPageItemNum = mod;
      } else {
        lastPageItemNum = this.perPage;
      }
      // 最終ページ以外は、現在の表示件数設定の値
      if (this.currentPage < maxPage) {
        return this.perPage;
      }
      // 最終ページが表示件数ぴったりの場合以外は、端数を表示
      return lastPageItemNum;
    },
  },
  watch: {
    'search.year': async function () {
      this.$store.dispatch('page/onWaiting');
      await this.initFetch();
      this.$store.dispatch('page/offWaiting');
    },
  },
  // ロード画面
  async created() {
    this.$store.dispatch('page/onLoading');
    this.oldPage = this.currentPage;
    this.$store.commit('cmsReportSearch/initSelectedAppid');
    const { year, seriesId } = this.$route.params;
    if (year) {
      this.setFilter('year', Number(year));
    }
    if (seriesId) {
      this.setFilter('series', Number(seriesId));
    }
    if (!this.search.year) {
      this.setFilter('year', Number(moment().format('YYYY')));
    }
    await this.initFetch();
    this.isInit = false;
    this.$store.dispatch('page/offLoading');
  },
};
</script>

<style>
  .cmsAppTable thead th:nth-of-type(1) {
    width: 140px !important;
  }
  .cmsAppTable thead th:nth-of-type(2) {
    width: 150px !important;
  }
</style>

<style scoped>
  #serchWrap input, #serchWrap select {
    height: 50px;
  }

  #NumberWrap {
    height: 50px;
  }

  .search_area {
    background: #DDD;
    padding: 10px;
    margin-bottom: 30px;
  }

  .searchMiddle {
    width: 205px;
  }

  .searchShort {
    width: 135px;
  }

  .searchSpace {
    margin-right: 15px;
  }

  #popover {
    cursor: pointer;
    color: #FFF !important;
    text-decoration: underline;
  }

  .link {
    color: #0A8EA7 !important;
    cursor: pointer;
  }

  .link:hover {
    text-decoration: underline;
  }

  .err-wrap>p{
    color: #dc3545;
  }
</style>
